import React, { useEffect, useState, useMemo } from "react";
import { api } from "../../app/Api/ApiSlice";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./storesStyles.css";

const Order = () => {
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation()
  const order = location.state;

  const navigate = useNavigate()


  // Send purchase order
  const sendPurchaseOrder = async () => {
    try {
      const response = await api.post(`/stores/orders`, {
        cartDetails: {
          cart: order.cart._id,
          store: order.store,
          products: order.items,
          shippingMethod: order.shippingMethod,
          shippingAddress: order.shippingAddress,
          buyerContacts: order.buyerContacts,
          receiverContacts: order.receiverContacts,
        }
      });
      if (response) {
        toast.success("Purchase order sent successfully");
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message || "Failed to send order");
    }
  };


  /* ========================
     Calculations
  ======================== */
  const subtotal = useMemo(() => {
    if (!order?.items) return 0;
    return order.items.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
  }, [order]);

  const tax = order?.tax || 0;
  const shipping = order?.shippingFee || 0;
  const discount = order?.discount || 0;

  const grandTotal = subtotal + tax + shipping - discount;

  /* ========================
     Loading & Empty States
  ======================== */
  if (isLoading) return <p>Loading order...</p>;

  if (!order)
    return <p className="not-found-msg">Order not found</p>;

  return (
    <div className="store-orders-container">
      <h2 className="page-title">
        {order.store.name} — Order Details
      </h2>

      {/* ========================
         Order Summary
      ======================== */}
      <div className="order-details">
        <div className="order-details-info">
          <strong>Order ID:</strong>
          {/* <span>{order._id}</span> */}
        </div>

        <div className="order-details-info">
          <strong>Cart Name:</strong>
          <span>{order.cart.name}</span>
        </div>

        <div className="order-details-info">
          <strong>Status:</strong>
          <span className={`order-status ${order.status}`}>
            {order.status || "Pending"}
          </span>
        </div>

        <div className="order-details-info">
          <strong>Placed On:</strong>
          <span>
            {new Date(order.createdAt).toLocaleDateString()}
          </span>
        </div>

        <div className="order-details-info">
          <strong>Payment Method:</strong>
          <span>{order.paymentMethod || "Not specified"}</span>
        </div>
      </div>

      {/* ========================
         Products Table
      ======================== */}
      {order.items?.length === 0 ? (
        <p className="not-found-msg">
          This order has no items.
        </p>
      ) : (
        <div className="table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Product</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {order?.items?.map(product => (
                <tr key={product._id}>
                  <td>
                    <img
                      src={product.image}
                      alt={product.title}
                      width={50}
                      height={50}
                      style={{ borderRadius: "6px" }}
                    />
                  </td>
                  <td>{product.title}</td>
                  <td>${product.price}</td>
                  <td>{product.quantity}</td>
                  <td className="order-total">
                    ${product.price * product.quantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ========================
         Price Breakdown
      ======================== */}
      <div className="price-breakdown">
        <div className="price-row">
          <span>Subtotal</span>
          <span>${subtotal}</span>
        </div>

        <div className="price-row">
          <span>Tax</span>
          <span>${tax}</span>
        </div>

        <div className="price-row">
          <span>Shipping</span>
          <span>${shipping}</span>
        </div>

        {discount > 0 && (
          <div className="price-row discount">
            <span>Discount</span>
            <span>- ${discount}</span>
          </div>
        )}

        <div className="price-row grand-total">
          <strong>Total</strong>
          <strong>${grandTotal}</strong>
        </div>
      </div>

      {/* ========================
         Consumer Actions
      ======================== */}
      <div className="order-actions">
        {order.status === "Pending" && (
          <button className="btn-danger">
            Cancel Order
          </button>
        )}

        <button className="btn-secondary" onClick={sendPurchaseOrder}>
          Reorder
        </button>

        {
          order.invoiced &&
          <button className="btn-primary" onClick={navigate(`/b/${order.store.name}/invoices/${order.invoice}`)}>
            View Invoice
          </button>
        }
      </div>

      <p onClick={()=>navigate(-1)} className="back-link">
        ← Back to orders
      </p>
    </div>
  );
};

export default Order;
